"use client";

import { motion, AnimatePresence } from "framer-motion";
import type { AiProfile } from "@/types/ai";

interface VoiceGlowRingProps {
  open: boolean;
  profile?: AiProfile | null;
}

export default function VoiceGlowRing({
  open,
  profile,
}: VoiceGlowRingProps) {
  const accent = profile?.brand?.primaryColor ?? "#C1A2FF";

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed inset-0 z-[10090] pointer-events-none voice-glow-ring"
          style={{ "--voice-accent": accent } as React.CSSProperties}
          aria-hidden="true"
        >
          <div className="voice-glow-ring__track" />
          <div className="voice-glow-ring__glow" />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
